import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App.js';
import './styles/base.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('No se encontró #root en el documento.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
